import type { ITopicsSDK } from '@1js/cortex-topics-bootstrapper';
import initializeLivePersonaCardAsync from 'owa-persona/lib/services/initializeLivePersonaCardAsync';
import { lazyGetTopicsSdkAsync } from 'owa-topic-annotations/lib/lazyFunctions';

export default function getTopicsSdkAsync(): Promise<ITopicsSDK> {
    // Initialize LPC initializes the Loki configuration, which is needed for the Topics SDK initialization.
    return initializeLivePersonaCardAsync().then(lazyGetTopicsSdkAsync.importAndExecute);
}
